export const colorCode = {
  innovativeBlue: '#00AEEF',
  professionalBlue: "#5081A5",
  professionalLightBlue: "rgba(0, 174, 239, 0.1)", // 認証前レイアウトの背景色

  white: '#fff',
}